import type {
  NewsletterPayload,
  TrackingEvent,
  TrackingPayload,
} from '~/types/tracking'
import { useUser } from '#storefront/composables'
import { getEmailHash } from '~/utils'
import { useRoute } from '#app/composables/router'
import { useMurId } from '~/composables/useMurId'

export const NewsletterAction = {
  Footer: 'sign up: footer',
  UserArea: 'sign up: myaccount',
} as const

const useNewsletterEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => void,
) => {
  return {
    trackNewsletter: async (trackableObject: NewsletterPayload) => {
      const sha256 = await getEmailHash(trackableObject.email)
      const { user } = await useUser()
      const gender = user.value?.gender
      const { murId, getMurId } = useMurId({ user: user.value })

      await getMurId()
      const payloadData = {
        event: 'newsletter_sign_up',
        category: 'newsletter',
        action: trackableObject.action,
        label: 'men:0,women:0,children:0',
        gender,
        customer_id: user.value?.id,
        eh: sha256,
        mur_id: trackableObject.referenceKey || murId.value,
      }

      track('newsletter_sign_up', {
        ...payloadData,
      })
    },
    unsubscribeNewsletter: async () => {
      const payloadData = {
        event: 'newsletter_unsubscribe',
        category: 'newsletter',
        label: 'account',
        action: 'unsubscribe',
      }
      track('newsletter_unsubscribe', {
        ...payloadData,
      })
    },
    newsletterDoi: async () => {
      const route = useRoute()
      const { user } = await useUser()
      const { murId, getMurId } = useMurId({ user: user.value })
      await getMurId()
      const scCustomer = route.query.sc_customer as string
      const mur_id = scCustomer ?? murId.value
      const eh = await getEmailHash(user.value?.email)

      const payloadData = {
        event: 'newsletter_doi',
        category: 'newsletter',
        label: '201: DOI set',
        action: 'double-opt-in',
        mur_id,
        eh,
      }
      track('newsletter_doi', {
        ...payloadData,
      })
    },
  }
}

export default useNewsletterEvents
